<div class="link" (click)="viewAllEntityComments($event)">
  {{ commentsLinkText }}
</div>

<app-modal [(visible)]="isCommentsModalVisible" header="Comments">
  <app-comments [commentItems]="commentItems"></app-comments>
</app-modal>
